"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Import/ScanQrDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _qrcodereact = require('qrcode.react');


var _forms = require('shared/services/forms');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');

var _common = require('../common');















const NO_KEYS = []

/* Screen 4: a QR code that opens the phone scan page, and the pages as they
 * arrive. Its "form changed" notices say a page arrived (or, opened without
 * a form key, that the phone created the draft). */
const ScanQrDialog = ({
  isOpen, orgKey, formKey = null, knownFormKeys = NO_KEYS, onClose, onOpenDraft,
}) => {
  const [draftKey, setDraftKey] = _react.useState(formKey)
  const [draft, setDraft] = _react.useState(null)
  // Pages the open draft had already: only new ones are "from your phone".
  const [firstPage, setFirstPage] = _react.useState(formKey ? null : 0)

  // The org's forms when the dialog opened, kept while it stays open.
  const latestKnown = _react.useRef.call(void 0, knownFormKeys)
  latestKnown.current = knownFormKeys
  const [known, setKnown] = _react.useState.call(void 0, () => new Set(knownFormKeys))
  _react.useEffect.call(void 0, () => {
    if (isOpen) {
      setKnown(new Set(latestKnown.current))
      return
    }
    setDraftKey(formKey)
    setDraft(null)
    setFirstPage(formKey ? null : 0)
  }, [isOpen, formKey])

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    let isCurrent = true
    const load = (key) => _forms.getForm.call(void 0, { OrgKey: orgKey, FormKey: key })
      .then(({ Form }) => {
        if (!isCurrent) return
        setDraft(Form)
        setFirstPage(first => _nullishCoalesce(first, () => ( Form.Pages.length)))
      })
      .catch(() => { /* the next notice tries again */ })
    if (draftKey) load(draftKey)
    const refresh = _common.throttle.call(void 0, () => { if (draftKey) load(draftKey) }, 1000)
    const stop = _forms.onFormChanged.call(void 0, notice => {
      if (notice.OrgKey !== orgKey || !notice.FormKey) return
      if (!draftKey) {
        if (!known.has(notice.FormKey)) setDraftKey(notice.FormKey)
        return
      }
      if (notice.FormKey === draftKey) refresh()
    })
    return () => {
      isCurrent = false
      refresh.cancel()
      stop()
    }
  }, [isOpen, orgKey, draftKey, known])

  const link = _common.scanLink.call(void 0, orgKey, formKey)
  const pages = draft && firstPage != null ? draft.Pages.slice(firstPage) : []
  const createdHere = !formKey && !!draft

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: isOpen, title: "Scan with your phone"   , className: "forms-qr", onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      , _react2.default.createElement('div', { className: "forms-qr--top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
        , _react2.default.createElement('div', { className: "forms-qr--code", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
          , _react2.default.createElement(_qrcodereact.QRCodeSVG, { value: link, size: 176, marginSize: 2, title: "Scan link" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
        )
        , _react2.default.createElement('div', { className: "forms-qr--how", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
          , _react2.default.createElement('h3', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Take a photo of each page"     )
          , _react2.default.createElement('ol', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}
            , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}, "Point your phone's camera at this code."      )
            , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Lay the page flat in good light and take a photo."          )
            , _react2.default.createElement('li', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, "Add the other pages, then tap "      , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}, "Upload"), ".")
          )
          , _react2.default.createElement('p', { className: "forms-qr--fallback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, "No QR reader? On your phone, open this link:"

            , _react2.default.createElement('span', { className: "forms-qr--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}},  link )
          )
        )
      )
      , _react2.default.createElement('div', { className: "forms-qr--pages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement('div', { className: "forms-qr--pages-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, "Pages from your phone · "     ,  pages.length )
          ,  createdHere && onOpenDraft && draft && (
            _react2.default.createElement(_Form.Button, { onClick: () => onOpenDraft(draft.FormKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, "Open " ,  draft.Name )
          )
        )
        , _react2.default.createElement('div', { className: "forms-qr--thumbs", 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
          ,  pages.map((p, i) => (
            _react2.default.createElement('figure', { key: p.FileKey, className: "forms-qr--thumb", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
              , _react2.default.createElement('img', { src: p.URL, alt: `Page ${(_nullishCoalesce(firstPage, () => ( 0))) + i + 1}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}} )
              , _react2.default.createElement('figcaption', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}, "Page " ,  (_nullishCoalesce(firstPage, () => ( 0))) + i + 1 )
            )
          ))
          , _react2.default.createElement('div', { className: "forms-qr--thumb forms-qr--thumb-waiting" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}, "Waiting for the next page…"    )
        )
      )
    )
  )
}

exports. default = ScanQrDialog
